<header class="header--{{ theme() }} pt-topbar header" #header>
  <div class="container py-3 pt-md-4 header__inner position-relative z-2">
    @if (title(); as title) {
      <h1 class="h2 text-max-width-sm">
        @if (subTitle(); as subTitle) {
          <small class="fs-body-md fw-normal d-inline-block w-100 mb-2 text-highlight">{{ subTitle }}</small>
        }
        <span class="d-inline-block w-100">{{ title }}</span>
      </h1>
    }
    @if (cleanIntro(); as intro) {
      <div
        class="markdown-content markdown-content--stripped"
        fstrDynamicContent
        [innerHTML]="intro | resizeHtmlImages | stripEmbed: undefined | safe"
      ></div>
    }

    <ng-content></ng-content>
  </div>
</header>
